import * as React from 'react';
import type { FC } from 'react';
import { useState, useEffect, useId } from 'react';
import { subscribe } from 'app/helpers/cable';
import { moneyAccurate as money } from 'app/helpers/money';
import { useLocales } from '../../locales';
import Claim from './Claim';
import image from '../images/cashback.svg';

type CashbackData = {
  amount: number;
  currency: string;
};

const useCashback = () => {
  const [cashback, setCashback] = useState<CashbackData>({ amount: 0, currency: '' });
  const channelId = useId();

  useEffect(() => {
    const { subscription, unsubscribe } = subscribe(
      {
        channel: 'CashbackChannel',
        channelId,
      },
      {
        connected: () => {
          subscription.perform('notify');
        },
        received: setCashback,
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  const onClaim = () => setCashback((prev) => ({ ...prev, amount: 0 }));

  return [cashback, onClaim] as const;
};

const Cashback: FC = () => {
  const [cashback, onClaim] = useCashback();
  const locales = useLocales();

  return (
    <div className="xo-game-cashback-wrapper">
      <div className="xo-game-cashback">
        <div className="xo-game-cashback_image">
          <img src={image} alt="" />
        </div>
        <div className="xo-game-cashback_divider" />
        <div className="xo-game-cashback_info">
          <div className="xo-game-cashback_title">{`${locales('cashback.current')}:`}</div>
          <div className="xo-game-cashback_amount">{money(cashback.amount, cashback.currency)}</div>
        </div>
        <div className="xo-game-cashback_divider" />
        <Claim hasCashback={cashback.amount > 0} onSuccess={onClaim} />
      </div>
    </div>
  );
};

export default Cashback;
